import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Clock = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/clock">
        <g id="clock">
          <path
            id="Vector"
            d="M7.9987 15.1667C4.04536 15.1667 0.832031 11.9534 0.832031 8.00004C0.832031 4.04671 4.04536 0.833374 7.9987 0.833374C11.952 0.833374 15.1654 4.04671 15.1654 8.00004C15.1654 11.9534 11.952 15.1667 7.9987 15.1667ZM7.9987 1.83337C4.5987 1.83337 1.83203 4.60004 1.83203 8.00004C1.83203 11.4 4.5987 14.1667 7.9987 14.1667C11.3987 14.1667 14.1654 11.4 14.1654 8.00004C14.1654 4.60004 11.3987 1.83337 7.9987 1.83337Z"
          />
          <path
            id="Vector_2"
            d="M10.4751 10.62C10.3884 10.62 10.3017 10.6 10.2217 10.5467L8.15505 9.31338C7.64172 9.00671 7.26172 8.33338 7.26172 7.74005V5.00671C7.26172 4.73338 7.48839 4.50671 7.76172 4.50671C8.03505 4.50671 8.26172 4.73338 8.26172 5.00671V7.74005C8.26172 7.98005 8.46172 8.33338 8.66839 8.45338L10.7351 9.68671C10.9751 9.82671 11.0484 10.1334 10.9084 10.3734C10.8084 10.5334 10.6417 10.62 10.4751 10.62Z"
          />
        </g>
      </g>
    </svg>
  );
};

Clock.displayName = 'Clock';
